module.exports = __webpack_public_path__ + "img/symbol_6.8a0ab015.png";